import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

export const analytics = Analytics({
  app: 'white-lotus-button',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-Z2774Z1ZWQ'],
    }),
  ],
})

export function trackEvent(name: string, payload?: Record<string, string | number>) {
  analytics.track(name, payload).catch(() => {
    // Analytics blocked (ad blockers, etc.) — never affect the experience.
  })
}
